export function PROLinkOrders (
  $translate,
  API,
  confirm,
  sessionObjAPI
) {
  var PROLinkOrders = function () {
    this.origin = sessionObjAPI.base().origin;
  };

  PROLinkOrders.prototype.hookUrl = function (order) {
    const self = this;

    return `${self.origin}workshop.html#/${order.vendor_id}/purchase_order/${order.id}`;
  };

  PROLinkOrders.prototype.buildItemParams = function (order) {
    var params = {};

    angular.forEach(order.purchase_order_items_attributes, (item, idx) => {
      if (item.prolink_sku) {
        params[`NEW_ITEM-EXT_PRODUCT_ID[${idx + 1}]`] = item.prolink_sku;
        params[`NEW_ITEM-CUST_FIELD13[${idx + 1}]`]   = item.item_code;
        params[`NEW_ITEM-QUANTITY[${idx + 1}]`]       = parseInt(item.quantity_ordered);
        params[`NEW_ITEM-PRICE[${idx + 1}]`]          = item.unit_cost;
        params[`NEW_ITEM-CUST_FIELD12[${idx + 1}]`]   = idx + 1;
      }
    });

    return params;
  };

  PROLinkOrders.prototype.buildParams = function (order) {
    const self = this;

    var queryString = {
      hookUrl          : self.hookUrl(order),
      type             : 'po submit',
      purchase_order_id: order.id,
      order_number     : order.order_number
    };

    queryString['NEW_ITEM-CUST_FIELD5[1]']  = order.order_number;
    queryString['NEW_ITEM-CUST_FIELD6[1]']  = '';
    queryString['NEW_ITEM-CUST_FIELD11[1]'] = sessionObjAPI.countrySettings().price_includes_tax ? 'Inc': 'Ex';
    queryString['NEW_ITEM-CUST_FIELD11[1]'] = 'Inc';
    queryString['HOOKURL']                  = `${API.url}/purchase_orders/prolink/${order.id}`;

    angular.extend(queryString, self.buildItemParams(order));

    return $.param(queryString);

  };

  PROLinkOrders.prototype.sendOrder = function (order) {
    const self = this;

    var message, type;
    var queryString = self.buildParams(order);
    var atRiskItems = order.purchase_order_items_attributes.filter(item => !item.prolink_sku);

    if (atRiskItems.length === 1) {
      message = $translate.instant('JS_SPACE.INTEGRATIONS.ONE_ITEM_NOT_PRODUCT', { name: 'PROLink' });
      type = 'warning';
    }
    else if (atRiskItems.length > 1) {
      message = $translate.instant('JS_SPACE.INTEGRATIONS.OVER_ONE_ITEM_NOT_PRODUCT', { name: 'PROLink', num: atRiskItems.length });
      type = 'warning';
    }
    else {
      message = $translate.instant('JS_SPACE.INTEGRATIONS.CONFIRM_SAVE_AND_SEND', { name: 'PROLink' });
    }

    return confirm.generic(message, type)
    .then(() => queryString);
  };

  return PROLinkOrders;
}